import gConf from 'gConf';

const { augeUrl } = gConf;

export const LOGIN_AUGE_URL = `${augeUrl}/login`;
export const MANAGE_AUGE_URL = `${augeUrl}/redirect`;

export const LOGIN_URL = () => {
  const { origin } = window.location;
  const systemId = '2';
  return `${LOGIN_AUGE_URL}?system_id=${systemId}&system_url=${origin}/login`;
};

export const MANAGE_URL = code => {
  const systemId = '1';
  return `${MANAGE_AUGE_URL}?system_id=${systemId}&system_code=${code}`;
};
